<template>
  <div id="capture">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import store, { modulesName } from '@/store';
import loading from 'utils/mixins/loading';
//constants
import storageKeys from '@/utils/constants/storageKeys.js';
import roles from '@/utils/constants/roles.js';

export default {
  name: 'App',
  mixins: [loading],
  computed: {
    ...mapState(modulesName.appModuleName, ['loading']),
  },
  watch: {
    loading: {
      immediate: true,
      handler(val) {
        val === true ? this.ShowWait() : this.HideWait();
      },
    },
    '$i18n.locale': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        localStorage.setItem(storageKeys.CURRENT_LANG_KEY, newVal);
      }
    },
  },
  mounted() {
    console.log('App mounted');
    if (
      store.getters[`${modulesName.userModuleName}/role`] === roles.SUPERVISOR
    ) {
      console.log('Supervisor');
      this.$tawkMessenger.$on('load', () => {
        console.log('load cHat');
        this.$tawkMessenger.hideWidget();
      });
    }
  },
  created() {
    if (
      window.location.protocol !== 'https:' &&
      window.location.href.indexOf('localhost') < 0
    ) {
      window.location.replace(window.location.href.replace('http:', 'https:'));
    }
  },
};
</script>
